module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_remer",
    attrs: {
      "epub:type": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XXI",
      "title": "XXI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("F")]), _vm._v("irst and foremost, I would like to thank my family for giving me the time and support to work on this second edition. I would also like to acknowledge BP for permission to publish this work, Tengasco for donating the digital well data from the Swan Creek field, and Randy Miller (Core Lab) for prior access to some XRD data. I greatly appreciate Lee McRae (BP), Tony McClain (BP), Chris Walker (BP), Angeni Jayawickramarajah (BP), Eden Martin (BP), Noel McInnis (retired BP), Art Donovan (Texas A&M), and Jean Hall (BHP), Pablo Cervantes (Hess), Uyen Nguyen (Jefferies), Dan Jarvie (Worldwide Geochemistry), Zhiyong He (ZetaWare), Robert D. Hatcher Jr. (University of Tennessee), and countless others for all of the various geological and engineering discussions that have influenced this second edition. Lastly, I would like to dedicate this book to my parents for providing me unconditional support and a steady hand through my life journey.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 75
// module chunks = 0